import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreateActionComponent } from 'app/dialogs/create-action/create-action.component';
import { AuthService } from 'app/services/auth.service';
import { CompanyService } from 'app/services/models/company.service';
import { RequestTaskService } from 'app/services/models/request-task.service';
import { TransactionProductService } from 'app/services/models/transaction-product.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-request-task',
  templateUrl: './update-request-task.component.html',
  styleUrls: ['./update-request-task.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateRequestTaskComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  @BlockUI('section-block2') blockUI2: NgBlockUI;
  @ViewChild('tableRowDetails') tableRowDetails: any;

  public contentHeader = null;
  requestForm!: FormGroup;
  products: any[] = [];
  isUpdate = true;
  public ColumnMode = ColumnMode;

  companies: any[] = [];
  companyPersons: any = [];
  selectedPersons: any[] = [];

  selectedCompany: any = null;
  selectedPerson: any;
  selectedCompanyPerson: any;

  date = new Date();
  date2 = moment().add(15, 'days').toDate();

  files: any[] = [];
  totalCount: number = 0;

  public selectedFiles: File[] = [];
  fileName: string = 'Dosya Seç'

  urgencyLevels = [
    { label: 'Çok Acil', value: 1 },
    { label: 'Acil', value: 2 },
    { label: 'Orta Acil', value: 3 },
    { label: 'Normal', value: 4 }
  ];

  statusList = [
    { label: 'Oluşturuldu', value: 1 },
    { label: 'Yapılıyor', value: 2 },
    { label: 'İptal Edildi', value: 3 },
    { label: 'Tamamlandı', value: 4 }
  ];

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date,
    parseDate: (dateString: string) => new Date(dateString),
    formatDate: (date: Date) => {
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
    }
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date2,
    parseDate: (dateString: string) => new Date(dateString),
    formatDate: (date: Date) => {
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
    }
  };

  constructor(
    private activatedRouter: ActivatedRoute,
    private requestTaskService: RequestTaskService,
    private modalService: NgbModal,
    private transactionProductService: TransactionProductService,
    private formBuilder: FormBuilder,
    private companyService: CompanyService,
    private toastrService: ToastrService,
    public authService: AuthService
  ) {

    this.requestForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.maxLength(100)]],
      description: [''],
      urgency: [4],
      startDate: [this.date],
      companyId: [null],
      companyPersonId: [null],
      personId: [null],
      endDate: [this.date2],
      status: [1]
    });
  }

  requestTask: any = {};
  transactionManagement: any[] = [];
  actions: any[] = [];
  ngOnInit(): void {

    this.contentHeader = {
      headerTitle: 'Talepler',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Talep Listesi',
            isLink: true,
            link: '/admin/request-task'
          },
          {
            name: 'Talep Güncelleme',
            isLink: false
          }
        ]
      }
    }

    this.requestTaskService.event$.subscribe(() => {
      this.activatedRouter.params.subscribe(async params => {
        await this.getByIdRequestTask(params['id']);
      })
    })
    this.activatedRouter.params.subscribe(async params => {
      await this.getByIdRequestTask(params['id']);
    })
  }

  updateChange() {
    this.isUpdate = !this.isUpdate;
  }

  async getRequestTaskFile(page, size, id) {
    const requestFileAuthorization = this.authService.isEndpointStatus('GET.Reading.GetRequestTaskFile');
    if (requestFileAuthorization) {
      const data = await this.requestTaskService.getRequestFiles(page, size, id);
      console.log(data);
      this.files = data.requestTask;
      this.totalCount = data.totalCount;
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles = [input.files[0]];
      this.fileName = input.files[0].name;
    }
  }

  getFileExtension(fileName: string): string {
    // Dosya uzantısını almak için split kullanıyoruz
    return fileName?.split('.').pop() || 'Bilinmiyor';
  }

  async createFile() {
    console.log(this.selectedFiles);
    console.log(this.requestTask.id);
    const data = await this.requestTaskService.createRequestFile(this.selectedFiles, this.requestTask.id);
    console.log(data);
    if (data.status) {
      this.toastrService.success(data.message);
      this.getByIdRequestTask(this.requestTask.id);
    } else {
      this.toastrService.error(data.message);
    }
  }

  async getByIdRequestTask(id) {
    this.blockUI.start("Talep yükleniyor..")
    const requestTaskAuthorization = this.authService.isEndpointStatus('GET.Reading.GetByIdRequestTask');
    if (requestTaskAuthorization) {
      const data = await this.requestTaskService.getByIdRequestTask(id);
      this.requestTask = data;
      console.log(this.requestTask);
      this.transactionManagement = this.requestTask.transactionManagements;
      this.actions = this.requestTask.actions;
      console.log(this.actions);
      await this.getRequestTaskFile(this.pageBasic - 1, this.selectedSize, this.requestTask.id);
      this.requestForm.patchValue({
        title: data.title,
        description: data.description,
        urgency: data.priority,
        companyId: data.companyId,
        companyPersonId: data.personId,
        personId: data.companyPersonId,
        startDate: data.startDate ? new Date(data.startDate) : null,
        endDate: data.endDate ? new Date(data.endDate) : null,
        status: data.status
      });

      this.selectedCompany = this.requestTask.companyId;
      this.selectedPerson = this.requestTask.personId;
      this.selectedCompanyPerson = this.requestTask.companyPersonId;

      this.date = new Date(data.startDate);
      this.date2 = new Date(data.endDate);

      await this.getAllCompanies();
      this.onCompanyChange({ id: this.selectedCompany });

    } this.blockUI.stop();
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllDetailCompany();
    this.companies = data;
    console.log(this.companies)
    const filterCompany = this.companies.find(p => p.id === 1);
    this.companyPersons = filterCompany.persons ?? [];
  }

  onCompanyChange(event) {
    console.log(event)
    this.selectedCompany = event.id;
    console.log(this.selectedCompany);
    const selectedCompany = this.companies?.find(p => p.id === event.id);
    console.log(selectedCompany);
    this.selectedPersons = selectedCompany?.persons ?? [];
  }

  createActions(id?: number) {
    const modal = this.modalService.open(CreateActionComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'modal modal-success'
    })
    modal.componentInstance.data = {
      requestTask: this.requestTask,
      actionId: id
    };
  }

  async getByIdTransactionProducts(id) {
    this.blockUI2.start("İşlem ürünleri yükleniyor...")
    const products = await this.transactionProductService.transactionManagementTransactionProductsById(id);
    console.log(products);
    this.products = products
    this.blockUI2.stop();
  }

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return 'Talep Oluşturuldu';
      case 2:
        return 'Yapılıyor';
      case 3:
        return 'İptal Edildi';
      case 4:
        return 'Tamamlandı';
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'badge badge-glow badge-info';    // Info class for status 1
      case 2:
        return 'badge badge-glow badge-warning';  // Danger class for status 2
      case 3:
        return 'badge badge-glow badge-danger'; // Success class for status 3
      case 4:
        return 'badge badge-glow badge-success'; // Warning class for status 4
      default:
        return 'badge badge-glow badge-secondary'; // Secondary class for unknown status
    }
  }

  getStatusTextTransaction(status: number): string {
    switch (status) {
      case 1:
        return 'Oluşturuldu';
      case 2:
        return 'Yapılıyor';
      case 3:
        return 'Tamamlandı';
      case 4:
        return 'İptal Edildi';
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusClassTransaction(status: number): string {
    switch (status) {
      case 1:
        return 'badge badge-glow badge-info';    // Info class for status 1
      case 2:
        return 'badge badge-glow badge-warning';  // Danger class for status 2
      case 3:
        return 'badge badge-glow badge-success'; // Success class for status 3
      case 4:
        return 'badge badge-glow badge-danger'; // Warning class for status 4
      default:
        return 'badge badge-glow badge-secondary'; // Secondary class for unknown status
    }
  }

  expandedRow: any;
  async rowDetailsToggleExpand(row) {
    const requestTransactionProducts = this.authService.isEndpointStatus('GET.Reading.TransactionByIdTransactionProducts');
    if (requestTransactionProducts) {
      this.products = [];
      // Eğer tıklanan satır zaten genişletilmişse, onu kapatalım
      await this.getByIdTransactionProducts(row.id);
      if (this.expandedRow === row) {
        this.tableRowDetails.rowDetail.toggleExpandRow(row);
        this.expandedRow = null;  // Satır kapatıldı, expandedRow'u sıfırlıyoruz
        return;
      }

      // Diğer satırları kapatalım
      if (this.expandedRow) {
        this.tableRowDetails.rowDetail.toggleExpandRow(this.expandedRow);
      }

      this.tableRowDetails.rowDetail.toggleExpandRow(row);

      this.expandedRow = row;  // Genişletilen satırı takip etmek için kaydediyoruz
      console.log(this.expandedRow);
    }
  }

  get rowHeight(): number {
    const length = this.products?.length || 0;

    if (length < 4) {
      return length * 100; // 5'ten küçükse 120 ile çarp
    } else if (length >= 4 && length <= 15) {
      return length * 57; // 5 ile 15 arasında ise 55 ile çarp
    } else {
      return length * 43; // 15'ten büyükse 35 ile çarp
    }
  }

  calculateTotal(count: number, price: number, discountRate: number, taxRate: number): number {
    let total = count * price;
    if (discountRate) {
      total -= (total * discountRate) / 100; // İndirimi düş
    }
    if (taxRate) {
      total += (total * taxRate) / 100; // Vergiyi ekle
    }
    return total;
  }
  async onSubmit() {
    if (this.requestForm.valid) {
      const selectedPersonId = this.selectedPerson ? this.selectedPerson.id : null;
      const selectedCompanyPersonId = this.selectedCompanyPerson ? this.selectedCompanyPerson.id : null;
      const startDate = new Date(this.requestForm.value.startDate);
      const endDate = new Date(this.requestForm.value.endDate);
      console.log(this.requestForm.value)

      const data = await this.requestTaskService.updateRequestTask(
        this.requestTask.id,
        this.requestForm.value.title,
        this.selectedCompany,
        this.requestForm.value.description,
        startDate,
        endDate,
        this.requestForm.value.personId,
        this.requestForm.value.urgency ?? 1,
        this.requestForm.value.companyPersonId,
        this.requestForm.value.status
      );

      if (data.status === true) {
        this.requestTaskService.sendEvent(true);
        this.updateChange();
        this.toastrService.success(data.message);
        this.blockUI.stop();
      } else {
        this.toastrService.error(data.message);
        this.blockUI.stop();
      }
    }
  }

  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;

  async onPageChange() {
    await this.getRequestTaskFile(this.pageBasic - 1, this.selectedSize, this.requestTask.id);

  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getRequestTaskFile(this.pageBasic - 1, this.selectedSize, this.requestTask.id);
  }
}
